import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import InfoIcon from 'components/icons/IconInfoNew';
import BrandTooltip from 'components/consumer/BrandTooltip';
import PDPFinancing from 'components/consumer/PDP/PDPFinancing';
import usePDPPrice from 'data-hooks/usePDPPrice';
import PDPPriceSection from '../PDPPriceSection';
import PDPPriceSectionUI from '../PDPPriceSection/PDPPriceSectionUI';
import PDPPriceAndFinancePlaceholder from './PDPPriceAndFinancePlaceholder';

const PDPPriceAndFinance = ({
  loading,
  isEditOrder,
  pdpIsModularBYOProduct,
}) => {
  const { state: locationState = {} } = useLocation() ?? {};

  const {
    price: priceFromRouterState,
    originalPrice: originalPriceFromRouterState,
  } = locationState;
  const { data: priceData } = usePDPPrice();

  if (loading && priceFromRouterState) {
    const hasDiscountFromRouterState =
      originalPriceFromRouterState &&
      originalPriceFromRouterState > priceFromRouterState;

    return (
      <div className="flex-1">
        <PDPPriceSectionUI
          price={originalPriceFromRouterState ?? priceFromRouterState}
          salePrice={priceFromRouterState}
          hasDiscount={hasDiscountFromRouterState}
          hasTieredDiscount={false}
        />
        <PDPFinancing loading={loading} />
        {!priceData?.clearanceStockPerSKU?.flashSale && priceData?.isClearance && (
          <BrandTooltip
            openOnHover
            className="ml-0 w-fit"
            iconSize="big"
            closeButtonClassName="lg:hidden"
            customIcon={
              <div className="text-sm text-red font-bold mt-1 flex justify-center items-center">
                <span>Final Sale</span>
                <InfoIcon
                  color="green"
                  height={13}
                  width={13}
                  aria-hidden="true"
                />
              </div>
            }
          >
            Clearance item: ineligible for returns except for items arriving
            damaged & documented by carrier. Ineligible for warranty claims
            unless reports of defects are submitted within 14 days of delivery,
            cosmetic damage isn&apos;t covered.
          </BrandTooltip>
        )}
      </div>
    );
  }

  return (
    <div>
      {loading ? (
        <PDPPriceAndFinancePlaceholder />
      ) : (
        !isEditOrder && (
          <PDPPriceSection pdpIsModularBYOProduct={pdpIsModularBYOProduct} />
        )
      )}

      <PDPFinancing loading={loading} />
    </div>
  );
};

PDPPriceAndFinance.propTypes = {
  isEditOrder: PropTypes.bool,
  loading: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
};

export default PDPPriceAndFinance;
